import {Component, MeshComponent, Property, TextComponent} from '@wonderlandengine/api';

/**
 * timeout-screen
 */
export class TimeoutScreen extends Component {
    static TypeName = 'timeout-screen';

    timeout = 2;

    start() {
        this.mesh = this.object.findByName('Mesh')[0].getComponent(MeshComponent);
        this.text = this.object.findByName('Text')[0].getComponent(TextComponent);
    }

    onActivate() {
        this.mesh.active = true;
        this.text.active = true;
        this.updateTimeout();
    }

    onDeactivate() {
        this.mesh.active = false;
        this.text.active = false;
    }

    updateTimeout() {
        this.text.text = `Respawn in\n` + this.timeout.toString();
        if (this.timeout < 1) {
            this.active = false;
            return;
        }

        setTimeout(() => {
            this.timeout -= 1;
            this.updateTimeout();
        }, 1000);
    }
}
